import BaseBubbleController from "./BaseBubbleController.js";
import {
  escapeBubbleHtml,
  formatBubbleTimestamp,
  renderBubbleFooter,
  renderMarkdownBubblePanel,
  renderMarkdownContent,
} from "./bubbleControllerHtml.js";

export default class AssistantTextBubbleController extends BaseBubbleController {
  constructor() {
    super("assistant-text", "assistant");
  }

  renderBubbleHtml(bubble) {
    const isComplete = bubble?.isComplete === true;
    const markdownHtml = isComplete
      ? renderMarkdownContent(bubble.content || "")
      : `<div class="bubble-controller-streaming-text" data-bubble-streaming-text="true">${escapeBubbleHtml(
          bubble.content || ""
        )}</div>`;
    const panelHtml = renderMarkdownBubblePanel({
      role: "assistant",
      html: markdownHtml,
      extraClassName: "bubble-controller-panel-text",
    });

    const footerHtml = renderBubbleFooter({
      role: "assistant",
      timestamp: bubble.showTimestamp
        ? formatBubbleTimestamp(bubble.timestamp)
        : "",
    });

    return [panelHtml, footerHtml].filter(Boolean).join("");
  }

  onBubbleInit(bubble, uiApi) {
    this.onBubbleUpdated(bubble, uiApi);
  }

  onBubbleUpdated(bubble, uiApi) {
    const textElement = uiApi?.query?.("[data-bubble-streaming-text]");
    if (textElement) {
      textElement.textContent = bubble?.content || "";
    }

    const timestampElement = uiApi?.query?.(".bubble-controller-timestamp");
    if (timestampElement && bubble?.showTimestamp) {
      timestampElement.textContent = formatBubbleTimestamp(bubble?.timestamp) || "";
    }
  }
}
